import useGetOpenOrders from '@hooks/useGetOpenOrders'
import React from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import {
    Container,
    SpinnerContainer,
    Subtitle,
    Title,
    Description,
    DescriptionStrong,
    InfoContainer,
    BaseButtonOverride
} from './NotFound.style'
import Spinner from 'parkdepot-shared/components/Spinner'
import Error from '@components/Error/Error.component'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { BUTTON_KIND } from 'parkdepot-shared/components/Buttons'
import Button from 'parkdepot-shared/components/Buttons/Button'
import carpayHomeRoute from '../../Home/route.const'
import { Trans, useTranslation } from 'react-i18next'
import { carpayLPNotFoundLocationSearchRoute } from '../route.const'

const CarpayLPNotFound = () => {
    const { search } = useLocation()
    const history = useHistory()
    const { t } = useTranslation()
    const searchParams = new URLSearchParams(search)
    const plate = searchParams.get('plate')
    const queryparams = new URLSearchParams(location.search)
    const { data, loading, error } = useGetOpenOrders({
        variables: {
            plates: [plate!] // should exist because of skip
        },
        skip: !plate,
        fetchPolicy: 'cache-and-network'
    })

    if (loading && !data) {
        return (
            <SpinnerContainer>
                <Spinner theme="primary" size="xl" />
            </SpinnerContainer>
        )
    }

    if (error) {
        return <Error />
    }

    // @ts-ignore
    if (data?.b2c_get_open_orders.orders.length > 0 || !plate) {
        return <Redirect to={carpayHomeRoute} />
    }

    return (
        <Container>
            <Title data-testid="not-found-title">{t('carpay.notFound.title')}</Title>

            <FormPlateInput disabled readOnly value={plate} width="100%" />

            <InfoContainer>
                <Subtitle>
                    <i className="wemolo-warning-circle" aria-hidden="true" />
                    <span>{t('carpay.notFound.subtitle')}</span>
                </Subtitle>
                <Description>
                    <Trans
                        i18nKey="carpay.notFound.description"
                        components={{
                            strong: <DescriptionStrong />
                        }}
                    />
                </Description>
            </InfoContainer>

            <Button
                id="correct-button"
                $kind={BUTTON_KIND.primary}
                onClick={() => history.push(carpayHomeRoute)}
                $size={BUTTON_SIZE.medium}
                overrides={{ BaseButton: BaseButtonOverride }}
            >
                {t('carpay.notFound.correct')}
            </Button>

            <Button
                id="confirm-button"
                $kind={BUTTON_KIND.secondary}
                onClick={() => history.push(`${carpayLPNotFoundLocationSearchRoute}?${queryparams.toString()}`)}
                $size={BUTTON_SIZE.medium}
                overrides={{ BaseButton: BaseButtonOverride }}
            >
                {t('carpay.notFound.confirm')}
            </Button>
        </Container>
    )
}

export default CarpayLPNotFound
